import $ from 'jquery'
import GroupType from '../enums/GroupType'

export default class UserSelectorUtils {
    static convertSelectedGroupsIntoSelectedUsersIfNecessary(allUserList, groupType, allUsersSelected, showDisabled, selectedGroups, UGREnabled, TZGEnabled) {
        return UserSelectorUtils.convertSelectedGroupsIntoSelectedUsersConsideringTeamOnlyIfNecessary(allUserList,
                                                                                                    groupType,
                                                                                                    allUsersSelected,
                                                                                                    showDisabled,
                                                                                                    selectedGroups,
                                                                                                    UGREnabled,
                                                                                                    TZGEnabled,
                                                                                                    false)
    }

    static convertSelectedGroupsIntoSelectedUsersConsideringTeamOnlyIfNecessary(allUserList,
                                                                                groupType,
                                                                                allUsersSelected,
                                                                                showDisabled,
                                                                                selectedGroups,
                                                                                UGREnabled,
                                                                                TZGEnabled,
                                                                                includeUserTeamOnly) {
        // this logic must be the same as in ReportParamsUtil.convertSelectedGroupsToSelectedUsersIfNecessary (ReportParamsUtil.java)
        if (!includeUserTeamOnly && (allUsersSelected ||
                                     selectedGroups.length === 0 ||
                                     UGREnabled && groupType === GroupType.USER_GROUP ||
                                     TZGEnabled && groupType === GroupType.TIME_ZONE_GROUP)) {
            return []
        }

        let selectedUsers = []
        for (let groupId in selectedGroups) {
            //noinspection JSUnfilteredForInLoop
            const usersInGroup = UserSelectorUtils.getUsersByGroup(allUserList, selectedGroups[groupId], groupType)
            selectedUsers = $.merge(selectedUsers, UserSelectorUtils.getActiveAndSelectedDisabledUsers(showDisabled, usersInGroup))
        }

        return selectedUsers
    }

    static getActiveAndSelectedDisabledUsers(showDisabled, users) {
        if (showDisabled)
            return users

        return $.grep(users, function(user) { /*see Bug 53301*/
            return user.active || user.enabled
        })
    }

    static getUsersByGroup(allUserList, groupId, groupType) {
        const groupTypeFieldId = (groupType === GroupType.USER_GROUP) ? "userGroupId" : "timeZoneGroupId"
        return Object.values(allUserList).filter(user => user[groupTypeFieldId] === groupId)
    }
}



// WEBPACK FOOTER //
// ./web/js/usersSelector/UserSelectorUtils.js